// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__ZL+Om","dashboardCards":"dashboard_dashboardCards__ug8rh"};